import { NgModule } from '@angular/core';
import { GenCartCouponComponent } from './cart-coupon.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { FormErrorsModule, IconModule } from '@spartacus/storefront';
import { CartCouponModule } from '@spartacus/cart/base/components';

@NgModule({
  declarations: [GenCartCouponComponent],
  exports: [GenCartCouponComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    IconModule,
    FormErrorsModule,
    CartCouponModule,
  ],
})
export class GenCartCouponModule {}
